



















import Vue from 'vue'
import _ from 'lodash'
import dynPlaceholder from '../dynPlaceholder.vue'
// @ts-ignore
import MaskedInput from 'vue-masked-input'
export default Vue.extend({
  name: 'UiMaskInput',
  components: {dynPlaceholder, MaskedInput},
  props: {
    name: {},
    value: String,
    placeholder: {},
    required: {type: Boolean, default: false},
    readOnly: {type: Boolean, default: false},
    error: Boolean,
    mask: {
      type: String,
      default: ''
    },
    placeholderChar: {
      type: String,
      default: '_'
    }
  },
  methods: {
    onBlur (event: UIEvent) {
      // @ts-ignore
      this.$emit('blur', _.trim(event as string))
    },
    onInput (event: string) {
      // @ts-ignore
      this.$emit('input', _.trim(event as string))
    }
  },
  computed: {
    currentValue: {
      get (): string {
        return this.value || ''
      },
      set () {
      }
    },
    showDynPldr (): boolean {
      return !!this.currentValue || this.error
    }
  }
})
